// extracted by mini-css-extract-plugin
export default {"container":"mainContent_container__BFvH-"};